import angular from 'angular';

const MODULE_NAME = 'recaps.services.documentResize';
let documentResizeModule = angular.module(MODULE_NAME, []);

class DocumentResizeService {
    constructor(
        $q,
        LogService,
        $injector,
        $window
    ) {
        this.$q = $q;
        this.LogService = LogService;
        this.$injector = $injector;
        this.$window = $window;
    }

    get StaffUserService() {
        // Only get the service when actually needed
        return this.$injector.get('StaffUserService');
    }

    get shouldResizeImages() {
        return !!this.StaffUserService.currentUser && 
               this.StaffUserService.currentUser.staff_app_resize_images === true;
    }

    get maxImageDimension() {
        return this.StaffUserService.currentUser ? 
               parseInt(this.StaffUserService.currentUser.staff_app_resize_images_max_pixel || 1500) : 
               1500;
    }

    get imageQuality() {
        return this.StaffUserService.currentUser ? 
               parseFloat(this.StaffUserService.currentUser.staff_app_resize_images_quality || 0.9) : 
               0.9;
    }
    
    documentIsNotImage(document){
        let type = null;
        let output = false;
        if (document.fileDataURL) {
        type = document.fileDataURL.substring(document.fileDataURL.indexOf(":") + 1, document.fileDataURL.indexOf("/"));
        }
        if (type && type !== 'image') {
            output = true;
        }
        return output;
    }
}

DocumentResizeService.$inject = ['$q', 'LogService', '$injector', '$window'];

documentResizeModule.service('DocumentResizeService', DocumentResizeService);
export default documentResizeModule;